"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackFiltersExceptions = exports.trackFilters = exports.FiltersEventType = void 0;
const react_1 = require("react");
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var FiltersEventType;
(function (FiltersEventType) {
    FiltersEventType["FILTERS_UPDATE"] = "\uD83D\uDE80 search.filter.update";
    FiltersEventType["FILTERS_REMOVE"] = "\uD83D\uDE80 search.filter.remove";
    FiltersEventType["FILTERS_EXCEPTION"] = "\uD83D\uDE80 search.filter.exception";
})(FiltersEventType || (exports.FiltersEventType = FiltersEventType = {}));
const trackFilters = (action) => {
    let eventMetadata = {};
    if (action.type === FiltersEventType.FILTERS_REMOVE) {
        eventMetadata = { label: action.payload.label };
    }
    else if (action.type === FiltersEventType.FILTERS_EXCEPTION) {
        eventMetadata = { type: action.payload.type };
    }
    (0, libs_tracking_events_1.track)({
        event: action.type,
        eventMetadata,
        _clear: true,
    });
};
exports.trackFilters = trackFilters;
const useTrackFiltersExceptions = (count, loading, error) => {
    (0, react_1.useEffect)(() => {
        if (error)
            return (0, exports.trackFilters)({
                type: FiltersEventType.FILTERS_EXCEPTION,
                payload: { type: 'timeout' },
            });
        if (count === 0 && !loading) {
            (0, exports.trackFilters)({
                type: FiltersEventType.FILTERS_EXCEPTION,
                payload: { type: 'noresults' },
            });
        }
    }, [count, loading, error]);
};
exports.useTrackFiltersExceptions = useTrackFiltersExceptions;
//# sourceMappingURL=trackFilters.js.map